const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Home = () => import('~/pages/home').then(m => m.default || m)
const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)

const Users = () => import('~/pages/users/index').then(m => m.default || m)
const UsersNew = () => import('~/pages/users/form').then(m => m.default || m)
const UsersEdit = () => import('~/pages/users/form').then(m => m.default || m)

const Activities = () => import('~/pages/activities/index').then(m => m.default || m)
const ActivitiesNew = () => import('~/pages/activities/form').then(m => m.default || m)
const ActivitiesEdit = () => import('~/pages/activities/form').then(m => m.default || m)

const ActivityCategories = () => import('~/pages/activitycategories/index').then(m => m.default || m)
const ActivityCategoriesNew = () => import('~/pages/activitycategories/form').then(m => m.default || m)
const ActivityCategoriesEdit = () => import('~/pages/activitycategories/form').then(m => m.default || m)

const Works = () => import('~/pages/works/index').then(m => m.default || m)
const WorksNew = () => import('~/pages/works/form').then(m => m.default || m)
const WorksEdit = () => import('~/pages/works/form').then(m => m.default || m)

const Billings = () => import('~/pages/billings/index').then(m => m.default || m)
const BillingsNew = () => import('~/pages/billings/form').then(m => m.default || m)
const BillingsEdit = () => import('~/pages/billings/form').then(m => m.default || m)

const Help = () => import('~/pages/help').then(m => m.default || m)

export default [
  { path: '/', name: 'welcome', component: Welcome },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  { path: '/home', name: 'home', component: Home },
  { path: '/settings',
    component: Settings,
    children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'password', name: 'settings.password', component: SettingsPassword }
    ] },

  { path: '/users', name: 'users', component: Users },
  { path: '/users/new', name: 'usersnew', component: UsersNew },
  { path: '/users/:id', name: 'usersedit', component: UsersEdit },

  { path: '/activities', name: 'activities', component: Activities },
  { path: '/activities/new', name: 'activitiesnew', component: ActivitiesNew },
  { path: '/activities/:id', name: 'activitiesedit', component: ActivitiesEdit },

  { path: '/activitycategories', name: 'activitycategories', component: ActivityCategories },
  { path: '/activitycategories/new', name: 'activitycategoriesnew', component: ActivityCategoriesNew },
  { path: '/activitycategories/:id', name: 'activitycategoriesedit', component: ActivityCategoriesEdit },

  { path: '/works', name: 'works', component: Works },
  { path: '/works/new', name: 'worksnew', component: WorksNew },
  { path: '/works/:id', name: 'worksedit', component: WorksEdit },

  { path: '/billings', name: 'billings', component: Billings },
  { path: '/billings/new', name: 'billingsnew', component: BillingsNew },
  { path: '/billings/:id', name: 'billingsedit', component: BillingsEdit },

  { path: '/help', name: 'help', component: Help },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js